"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var api_request_1 = require("../api_request");
var url_helpers_1 = require("../shared/url_helpers");
var ArticleEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleEmbed, _super);
    function ArticleEmbed(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            article: null,
        };
        return _this;
    }
    ArticleEmbed.prototype.componentDidMount = function () {
        var _this = this;
        var req = api_request_1.V3.get(url_helpers_1.default.articlesMultiplePath(), { slugs: [this.props.slug] });
        req.then(function (response) {
            _this.setState({ article: response.articles[0] });
        });
    };
    ArticleEmbed.prototype.render = function () {
        var article = this.state.article;
        if (!article) {
            return null;
        }
        return (React.createElement("aside", { className: "article-embed", "data-heading": I18n.t('discovery.articleEmbed.header') },
            React.createElement("a", { href: article._links.web.href },
                React.createElement("div", { className: "article-embed__image" },
                    React.createElement("img", { src: article.photo })),
                React.createElement("div", { className: "article-embed__details" },
                    React.createElement("h1", { className: "article-embed__title" }, article.title),
                    React.createElement("div", { className: "article-embed__summary" },
                        article.summary,
                        React.createElement("div", { className: "article-embed__summary__readmore" }, I18n.t('discovery.articleEmbed.readmore')))))));
    };
    return ArticleEmbed;
}(React.Component));
exports.default = ArticleEmbed;
//# sourceMappingURL=article_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/article_embed.js
// module id = ppIG
// module chunks = 20 21